import type {SchedulerDashboardActions} from 'src/action-creators/scheduler/dashboard';
import {SET_TEAM_MEMBER_ANALYTICS} from 'src/action-creators/scheduler/dashboard';

import type {TeamMemberIdAndDetails} from 'src/types/scheduler/dashboard';

import keyBy from 'lodash/keyBy';


export type SchedulerDashboardState = {
  teamMemberAnalytics: TeamMemberIdAndDetails;
};

export const initialState: SchedulerDashboardState = {
  teamMemberAnalytics: {},
};

export default function schedulerDashboard(
  state: SchedulerDashboardState | null | undefined = initialState,
  action: SchedulerDashboardActions,
): SchedulerDashboardState {
  switch (action.type) {
    case SET_TEAM_MEMBER_ANALYTICS:
      return {
        ...state,
        teamMemberAnalytics: keyBy(action.payload, 'agentId'),
      };
    default:
      // @ts-expect-error - TS2322 - Type 'SchedulerDashboardState | null' is not assignable to type 'SchedulerDashboardState'.
      return state;
  }
}
